export const TOOLTIP_OFFSET = -27;
export const DISABLED_IMAGE_MAX_LEN = 10;
